import { client } from "../../../lib/api";
import type { ProfileSavePayload } from "../../../generated-api";

export async function upsertProfile(data: ProfileSavePayload): Promise<void> {
  if (!data) return;

  await client.users.patchUsersProfileContext({
    requestBody: data,
  });
}
